<template>
  <div class="file-upload-details">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns" style="margin-top: 16px">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ pageTitle }}</p>
                  </header>
                </div>
              </div>
              <div class="columns" style="margin-top: 16px; margin-left: 0">
                <div class="column is-full">
                  <b-field class="file" :class="{'has-name': !!selectedFile}">
                    <b-upload v-model="selectedFile" class="file-label"
                              accept=".jpg, .jpeg, .png, .pdf, .txt, .zip, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .rtf"
                              @input="onFileSelected">
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">{{ $t('file-upload-details-view.select-file-button') }}</span>
                      </span>
                      <span class="file-name" v-if="selectedFile">
                        {{ selectedFile.name }}
                      </span>
                    </b-upload>
                    <b-button v-if="isFileSelected" class="button is-primary is-danger" icon-left="delete"
                              @click="onFileRemoveSelected"></b-button>
                  </b-field>
                </div>
              </div>
              <div v-if="!selectedFile" class="column">
                <span class="is-size-6">{{ $t('file-upload-details-view.file-allowed-size') }}</span><br/>
                <span class="is-size-6">{{ $t('file-upload-details-view.file-allowed-type') }}</span>
              </div>
              <div class="columns" style="margin-top: 16px">
                <div class="column is-full">
                  <b-field :label="$t('file-upload-details-view.description-text-field')">
                    <b-input v-model="fileDescription"
                             :placeholder="$t('personal-details-view.personal-text-placeholder')"
                             type="textarea" tabindex="16"></b-input>
                  </b-field>
                </div>
              </div>
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column is-narrow">
                  <b-button class="button" @click="cancelClicked" icon-left="close-thick" tabindex="31">
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
                <div class="column is-narrow">
                  <b-button v-if="currentUserAccess('ProjectFilesDetails', this.UserActions.UPDATE, this.project_id)"
                            class="button is-primary" @click="uploadClicked" icon-left="content-save" tabindex="32">
                    {{ $t('file-upload-details-view.upload-button') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "FileUploadDetails",
  props: {
    'project_id': {
      type: String
    }
  },
  data() {
    return {
      selectedFile: null,
      fileDescription: "",
      isLoading: false
    }
  },
  methods: {
    onFileSelected() {
      console.log("Selected file: ", URL.createObjectURL(this.selectedFile))
    },
    onFileRemoveSelected() {
      this.selectedFile = null
    },
    uploadFile: function () {
      if (this.selectedFile !== null && this.selectedFile !== undefined) {
        this.isLoading = true;
        let userEmail = firebase.auth().currentUser.email
        let metadata = {
          customMetadata: {
            'description': this.fileDescription,
            'email': userEmail
          }
        };
        this.getFileRef().put(this.selectedFile, metadata).then((snapshot) => {
          this.isLoading = false;
          console.log('Project file is uploaded: ', snapshot.metadata);
          this.$emit('fileUploaded');
        }).catch((error) => {
          this.showError(error.message)
          console.log('File upload error: ', error.message);
        });
      } else {
        console.log("No project file is selected!")
      }
    },
    getFileRef: function () {
      const filePath = this.getStorageRootFolder() + '/projects/' + this.project_id + '/files/' + this.selectedFile.name
      console.log("file ref: ", filePath)
      return firebase.storage().ref(filePath)
    },
    /*
     UI Events
     */
    cancelClicked: function () {
      this.$emit('close');
    },
    uploadClicked: function () {
      this.uploadFile()
    }
  },
  computed: {
    isFileSelected() {
      return this.selectedFile !== null && this.selectedFile !== undefined && this.selectedFile !== "";
    },
    pageTitle() {
      return this.$t('file-upload-details-view.title')
    }
  }
};
</script>
